











import {Component, Prop, Vue, Watch} from "vue-property-decorator";

@Component
export default class FlowRelation extends Vue {
  @Prop({
    type: String,
    default() {
      return '';
    }
  })
  value!: string;

  public label = '';

  @Watch('value')
  getLabel(newVal: string) {
    if (newVal === 'AND') {
      this.label = '且';
    } else if (newVal === 'OR') {
      this.label = '或';
    } else {
      this.label = '';
    }
  }

  created() {
    this.getLabel(this.value);
  }

}

